<template>
  <div class="additional-options-block">
    <p class="additional-options-block__title title" @click="emit('toggleFilter')">
      Оказываемые услуги
      <span v-if="searchStore.additionalOptionsFilters" class="title_green">
        Указаны {{ searchStore.additionalOptionsFilters }} параметр
      </span>
      <span v-else class="title_green">
        Не указаны
      </span>
      <ArrowIcon
        class="title__arrow"
        :class="{ 'title__arrow_active': visibleFiltersAdditionalOptions }"
      />
    </p>

    <transition name="fade-slide">
    <div v-if="visibleFiltersAdditionalOptions" class="additional-options-block-wrapper">
      <div class="additional-options-block__element" v-for="group in additionalOptions" :key="group.id">
        <p class="additional-options-block__title">
          {{ group.name }}
        </p>

        <div class="additional-options-block__options">
          <div class="additional-options-block__option" v-for="option in group.additionalOptions" :key="option.id">
            <pCheckbox
              :modelValue="searchStore.searchOptions.additionalOptions.includes(option.id)"
              :label="option.name"
              @update:modelValue="toggleAdditionalOption(option.id)"
            />
          </div>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, Ref } from 'vue';
import { useSearchStore } from "@/searchSection/store/searchStore";
import api from "@/searchSection/api";
import { GroupAdditionalOption } from '@/searchSection/types/AdditionalOption';
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
const searchStore = useSearchStore()
import ArrowIcon from '@/common/icons/ArrowIcon.vue';


defineProps<{ visibleFiltersAdditionalOptions: boolean }>();
const emit = defineEmits(['toggleFilter']);
const additionalOptions: Ref<GroupAdditionalOption[]> = ref([]);

function toggleAdditionalOption(optionId: number) {
  if (searchStore.searchOptions.additionalOptions.includes(optionId)) {
    searchStore.searchOptions.additionalOptions = searchStore.searchOptions.additionalOptions.filter(id => id !== optionId);
  } else {
    searchStore.searchOptions.additionalOptions.push(optionId);
  }
}

onMounted(async () => {
  try {
    const additionalOptionsResponse = await api.getAdditionalOptions()
    additionalOptions.value = additionalOptionsResponse
  } catch (e) {
    window.showNotification('Произошла ошибка!', 'error')
  }
})

</script>

<style scoped lang="scss">
.additional-options-block {
  &-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    height: 725px;
    width: 100%;
    row-gap: 30px;
    margin-top: 15px;
    transition: all .3s ease-out;

    @media screen and (max-width: 565px) {
      display: grid;
      grid-template-columns: 1fr;
      height: unset;
    }
  }

  &__element {
    display: block;
    flex-direction: column;
    row-gap: 10px;
    width: calc(100% / 3);

    @media screen and (max-width: 565px) {
      width: 100%;
    }

    &:nth-child(3n + 1) { order: 1; }
    &:nth-child(3n + 2) { order: 2; }
    &:nth-child(3n) { order: 3; }

    & > *:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  &__options {
    display: flex;
    row-gap: 10px;
    flex-direction: column;
    
    .additional-options-block__option {
      height: 20px;
    }
  }
}
</style>